/**
 * IndicadoresProducao - Cards com métricas de produção
 */
import React from 'react';
import { Card, CardContent } from '../ui/card';

const IndicadoresProducao = ({ indicadores }) => {
  return (
    <div className="grid grid-cols-2 md:grid-cols-5 gap-3" data-testid="indicadores-producao">
      <Card>
        <CardContent className="pt-4">
          <div className="text-center">
            <p className="text-2xl font-bold">{indicadores.totalFases}</p>
            <p className="text-xs text-gray-500">Total Fases</p>
          </div>
        </CardContent>
      </Card>
      
      <Card className="border-l-4 border-l-orange-400">
        <CardContent className="pt-4">
          <div className="text-center">
            <p className="text-2xl font-bold text-orange-500">{indicadores.pendentes}</p>
            <p className="text-xs text-gray-500">Pendentes</p>
          </div>
        </CardContent>
      </Card>
      
      <Card className="border-l-4 border-l-blue-500">
        <CardContent className="pt-4">
          <div className="text-center">
            <p className="text-2xl font-bold text-blue-600">{indicadores.emAndamento}</p>
            <p className="text-xs text-gray-500">Em Andamento</p>
          </div>
        </CardContent>
      </Card>
      
      <Card className="border-l-4 border-l-green-500">
        <CardContent className="pt-4">
          <div className="text-center">
            <p className="text-2xl font-bold text-green-600">{indicadores.concluidas}</p>
            <p className="text-xs text-gray-500">Concluídas</p>
          </div>
        </CardContent>
      </Card>
      
      <Card className="border-l-4 border-l-red-500">
        <CardContent className="pt-4">
          <div className="text-center">
            <p className="text-2xl font-bold text-red-600">{indicadores.atrasadas}</p>
            <p className="text-xs text-gray-500">Em Atraso</p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default IndicadoresProducao;
